import { GetServerSideProps, NextPage } from 'next';

const RedirectToExhibitorsPagination: NextPage = () => null;

// Redirect to first paginated page 1
export const getServerSideProps: GetServerSideProps<Record<string, unknown>, { eventId: string }> =
  async ({ params }) => ({
    redirect: {
      permanent: true,
      destination: `/event/${params?.eventId}/exhibitors/page/1`,
    },
  });

export default RedirectToExhibitorsPagination;
